'use strict';

import {RSA} from 'javascript/libs/base/rsa.js';
// import {sha256} from 'javascript/libs/base/sha256.js';
import sha256 from 'crypto-js/sha256.js';

let hostname = location.hostname
	, key = ''
	;

if( hostname.indexOf('test.66buy.com.cn') > 0 ){
	key = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCAWng3fmNcCiKNliqo6QtdzgJMkYeNKDvnKF44Yq7xML9/ISYMiI/9zucZWPb2LpdhwBbRqMCJtXOzYjVHz+3XrYvam+HXs5Q4joMJV+UXOoU8PGRyTffUsGD5DFd2mcbB0Y31vjNRETqrkMVS1nOAdb42MG0GfYYhvU+wxhcfMwIDAQAB';
}
else if( hostname.indexOf('pre.66buy.com.cn') > 0 || hostname.indexOf('51tiangou.com') > 0 ){
	key = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCw3xC+94WJm3bY2kiaiJodq/PXpMzPEd5XJHRWSq8afRKGBFt1ZaDST9KStxrskuDCY8NzJpC4aJ8ep/W3HVePJFDukiFFnfmmCwKTfh0TSDnefSMRFuHj+h280Q9jqzfrSB7drHFxn/cykpyR28MmS+JFe01INNEpeRgoSrmUKwIDAQAB';
}

export default {
	key
	, getDesWord(oldWord){
		return RSA(oldWord, key);
	}
	, getSHA256Str(obj){
		//去除obj里面value为空的key
		//按字典序排序key
		//key=XXX 用&拼接成字符串
		//md5加密字符串
		let objStr = ''
			;

		_.keys(obj).filter((i)=>{
			return obj[i] !== undefined && obj[i] !== null;
		}).sort((a, b)=>{
			let len = a.length > b.length?b.length:a.length
			;

			for(let i = 0;i<len;i++){
				if(a.charCodeAt(i) !== b.charCodeAt(i)){
					return a.charCodeAt(i) - b.charCodeAt(i);
				}
			}
		}).forEach(key => {
			objStr += key+'='+obj[key]+'&';
		})
		return sha256(objStr.slice(0,-1));
	}
	, makeDataObj(dataObj){
		//获取后台时间戳
		//业务参数+时间戳 ==>md5==> nonce字符串
		//业务参数+时间戳+nonce ==>md5+rsa==> sign字符串
		//业务参数+时间戳+nonce+sign  安全的传参

		dataObj.nonce = this.getSHA256Str( dataObj );
		dataObj.sign = this.getDesWord( this.getSHA256Str(dataObj) );

		return dataObj;
	}
};